"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrenciesList = exports.getCountryByAlpha2 = void 0;
const constants_1 = require("../data/constants");
const countriesList_1 = __importDefault(require("../data/countriesList"));
const fiatCurrencies_1 = __importDefault(require("../data/fiatCurrencies"));
/**
 * Returns country data and
 *
 * @param alpha2 2 character ISO country code (default US)
 * @returns CountryDataType
 */
const getCountryByAlpha2 = (alpha2) => {
    const country = countriesList_1.default.find((i) => i.alpha2 === alpha2);
    if (!country)
        return countriesList_1.default.find((i) => i.alpha2 === constants_1.FALLBACK_COUNTRY);
    return country;
};
exports.getCountryByAlpha2 = getCountryByAlpha2;
/**
 * Gets object of Currency codes and names
 *
 * @param defaultCurrency optional deault fiat to be included at 0
 * @returns CurrencyType
 */
const getCurrenciesList = (defaultCurrency) => {
    // creates object of all fiat currencies requested
    const rawCurrencies = fiatCurrencies_1.default.reduce((p, c) => (Object.assign(Object.assign({}, p), { [c.abbr]: c })), {});
    // create object of all 'priority' fiats
    const priorityCurrencies = constants_1.PRIORITY_FIAT.reduce((p, c) => (defaultCurrency !== c ? Object.assign(Object.assign({}, p), { [c]: rawCurrencies[c] }) : p), {});
    // create object of all non priority fiats
    const otherCurrencies = Object.keys(rawCurrencies).reduce((p, c) => !constants_1.PRIORITY_FIAT.includes(c) && defaultCurrency !== c
        ? Object.assign(Object.assign({}, p), { [c]: rawCurrencies[c] }) : p, {});
    // if has default currency put that first
    if (defaultCurrency && rawCurrencies[defaultCurrency])
        return Object.assign(Object.assign({ [defaultCurrency]: rawCurrencies[defaultCurrency] }, priorityCurrencies), otherCurrencies);
    // if no default then just return list of currencies with priority first
    return Object.assign(Object.assign({}, priorityCurrencies), otherCurrencies);
};
exports.getCurrenciesList = getCurrenciesList;
//# sourceMappingURL=intl.js.map